
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { addDays } from "date-fns";


import CallAlertBar from "../../../Layout/Alertbar";

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PurchaseReceiveActionMenu from "../receives/PurchaseReceivesMenu";
import CustomTableContainer from "../../../Layout/CustomTableContainer";

import useEmployee from "../../../hooks/useEmployee";
import jsPDF from 'jspdf';

import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import useLoadVendorDetailById from "../../../hooks/useVendorGetDetailByID";
import useLoadCompanyDetailById from "../../../hooks/useLoadCompanyDetail";
import GoodsReceiptNote from "../reports/PurchaseReceivesReport";
import useVendorListByType from "../../../hooks/useVendorListByType";
import usePurchaseReceivedTableDet from "../../../hooks/usePurchaseReceivedTableDet";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import useVendorListByTypeDesc from "../../../hooks/useVendorListByTypeDesc";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


const EmployeeSelector = ({ label, employeeList, selectedEmployee, onChange }) => (
  <Autocomplete
    size="small"
    fullWidth
    options={employeeList}
    value={selectedEmployee}
    onChange={(event, newValue) => onChange(newValue)}
    getOptionLabel={(option) => option?.name || ''}
    renderInput={(params) => (
      <TextField {...params} label={label} required variant="outlined" />
    )}
  />
);




const AddNewPurchaseReceive = ({ handlecallback, editPurchaseOrderNumber, editPurchaseReceiveNumber, editPurchaseReceiveID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  // List of Parameter
  const [selectedPartyID, setSelectedPartyID] = useState(0);
  const [selectedParty, setSelectedParty] = useState(null);
  const [selectedPOID, setSelectedPOID] = useState(0);
  const [selectedPONumber, setSelectedPONumber] = useState(null);

  const [customerNotes, setCustomerNotes] = useState('');
  const [orderFromDate, setOrderFromDate] = useState(dayjs());

  const [isLoadEditPO, setLoadEditPO] = useState(false);
  const [isLoadEditPR, setLoadEditPR] = useState(false);

  const [tableRows, setTableRows] = useState([{ id: 1, product_code: '', product_description: '', ordered: 0, received: 0, quantity_balance: 0, in_transit: 0, quantity_to_received: 0 }]);
  // const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID, } = useEmployee(0);

  const [poNumber, setPONumber] = useState([]);
  const [isPONumberLoaded, setIsPONumberLoaded] = useState(false);

  const [prNumber, setPRNumber] = useState([]);
  const [isPRNumberLoaded, setIsPRNumberLoaded] = useState(false);

  // get party list
  const [partyList, setPartyList] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [selectedButtonName, setSelectedButtonName] = useState('');

  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(dayjs());

  const [vehicleNumber, setVehicleNumber] = useState('');
  const [doNumber, setDONumber] = useState('');
  const [doDate, setDODate] = useState(dayjs());

  // employee selector
  const receivedByHook = useEmployee(); // or useEmployee(receivedByID)
  const approvedByHook = useEmployee();
  const inspiredByHook = useEmployee();

  const { vendorDetails, setVendorList, loadVendorDetail } = useLoadVendorDetailById();
  const { companyDetails, setCompanyDetail, loadCompanyDetail } = useLoadCompanyDetailById();
  const { partyByType, selectedpartyByTypeID, selectedpartyByType, setPartyByType, setSelectedpartyByTypeID, setSelectedpartyByType, loadPartyListByCategory, } = useVendorListByTypeDesc();
  const [isTransporterLoaded, setIsTransporterLoaded] = useState(false);
  const { receivesDetail, setReceivesDetail, loadReceivesDet } = usePurchaseReceivedTableDet();
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });

  useEffect(() => {
    if (!isTransporterLoaded) {
      loadPartyListByCategory(null, 'Transporter');
    }
  }, [isTransporterLoaded])


  const LoadReceivesDetails = async (PurchaseID) => {
    try {

      const para = { p_companyid: localStorage.getItem('companyid'), purchase_order_id: PurchaseID, purchase_receive_number: editPurchaseOrderNumber };
      const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHSE_RECEIVE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para);
      setTableRows(purchaseOrderResponse);

    } catch (error) { callMessage('error', error.message, 'Error'); }
  }



  const didFetchData = useRef(false);
  const controllerRef = useRef(null);

  useEffect(() => {
    const fetchPurchaseOrderData = async () => {
      // Check if fetch process is already running
      if (didFetchData.current) {
        return;
      }
      didFetchData.current = true;

      // Create an AbortController to cancel fetch if needed
      controllerRef.current = new AbortController();
      const { signal } = controllerRef.current;

      let po_id = editPurchaseOrderNumber;
      let pr_id = editPurchaseReceiveNumber;

      try {

        const isEditPO = !isLoadEditPO && editPurchaseOrderNumber !== 0 && editPurchaseReceiveID === 0;
        const para = { p_companyid: 1, purchase_order_id: editPurchaseOrderNumber };
        const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, para, { signal });

        // Log the response to see its structure
        console.log('purchaseOrderResponse:', purchaseOrderResponse);

        // Check if purchaseOrderResponse is an array and has at least one element
        if (!purchaseOrderResponse || purchaseOrderResponse.length === 0) {
          throw new Error('No purchase order data found');
        }

        const purchaseOrder = purchaseOrderResponse[0];

        // Check if purchaseOrder has the expected properties
        if (!purchaseOrder || !purchaseOrder.id_party) {
          throw new Error('Invalid purchase order data');
        }

        const purchasereceivesPara = { p_companyid: 1, purchase_order_id: po_id, purchase_receive_number: isEditPO ? 0 : pr_id };
        const purchaseOrderPara = { p_companyid: 1, p_partyid: purchaseOrder.id_party };

        const [poData, tableData] = await Promise.all([
          callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, purchaseOrderPara, { signal }),
          callApi(API_ENDPOINTS.PURCHSE_RECEIVE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, purchasereceivesPara, { signal })
        ]);



        if (poData && poData.length > 0) setPONumber(poData);
        if (tableData && tableData.length > 0) setTableRows(tableData);

        if (purchaseOrder) {
          const selected = poData.find(po => po.po_number === purchaseOrder.purchase_order_number);
          if (selected) {
            setSelectedPONumber(selected);
            setSelectedPOID(selected.id);
          }
          setSelectedPartyID(purchaseOrder.id_party);
          updatePartyListAndSetSelectedParty(purchaseOrder.id_party);
          loadVendorDetail(purchaseOrder.id_party);
          updateFormData(tableData, purchaseOrder);

        }

        didFetchData.current = false; // Reset the flag after fetching data
      } catch (error) {
        if (signal.aborted) {
          console.log('Fetch aborted');
        } else {
          callMessage('error', error.message, 'Error');
          // console.error('Error:', error);
        }
        didFetchData.current = false; // Reset the flag if an error occurs
      }
    };

    // Only call fetchPurchaseOrderData if necessary
    if (!didFetchData.current) {
      fetchPurchaseOrderData();
    }

    // Cleanup function to cancel fetch if the component unmounts
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [editPurchaseOrderNumber, editPurchaseReceiveID]);


  const updatePartyListAndSetSelectedParty = (selectedPartyID) => {

    const para = { p_companyid: localStorage.getItem('companyid'), }

    callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => { if (data && data.length > 0) { setPartyList(data); const selected = data.find(party => party.id === selectedPartyID); if (selected) { setSelectedParty(selected); } } })
      .catch(error => { callMessage('error', error.message, 'Error'); });
  };





  const handleQuantityChange = (index, quantity) => {
    setTableRows((prevRows) => {
      return prevRows.map((row, i) => {
        if (i === index) {
          const numericQuantity = Number(quantity); // Ensure quantity is a number
          return (row.quantity_balance + row.received) <= numericQuantity
            ? row  // Return unchanged row if condition is not met
            : { ...row, quantity_to_received: quantity }; // Create a new object for state change detection
        }
        return row;
      });
    });
  };


  useEffect(() => {
    if (!isDataLoaded) {

      const para = { p_companyid: localStorage.getItem('companyid'), }

      callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => { if (data && data.length > 0) { setPartyList(data); } })
        .catch(error => { callMessage('error', error.message, 'Error'); });
    }

  }, [isDataLoaded]);


  useEffect(() => {
    if (!isPONumberLoaded) {
      if (editPurchaseOrderNumber = 0) {

        const para = { p_companyid: localStorage.getItem('companyid'), p_modeid: 0, }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
          .then(data => { if (data && data.length > 0) { setPONumber(data[0].po_number); } })
          .catch(error => { callMessage('error', error.message, 'Error'); });

      }
    }
  }, [isPONumberLoaded]);


  const handleGetPOList = (PartyID) => {

    const para = { p_companyid: localStorage.getItem('companyid'), p_partyid: PartyID, }

    callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => { if (data && data.length > 0) { setPONumber(data); } })
      .catch(error => { callMessage('error', error.message, 'Error'); });
  }



  useEffect(() => {
    if (!isPRNumberLoaded) {
      if (editPurchaseReceiveID === 0) {

        const para = { p_companyid: localStorage.getItem('companyid'), p_modeid: 0, }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PR_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
          .then(data => { if (data && data.length > 0) { setPRNumber(data[0].pr_number); } })
          .catch(error => { callMessage('error', error.message, 'Error'); });

      }
      else {
        setPRNumber(editPurchaseReceiveNumber);

      }
    }
  }, [isPRNumberLoaded]);

  const [updateReceivedDetail, setUpdateReceivedDetail] = useState(false);
  useEffect(() => {
    if (editPurchaseReceiveID !== 0) {
      loadReceivesDet(editPurchaseReceiveID);
    }
  }, [editPurchaseReceiveID]);

  useEffect(() => {

    if (editPurchaseReceiveID !== 0) {

      const para = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1, p_id_receives: editPurchaseReceiveID, }

      callApi(API_ENDPOINTS.PURCHASE_RECEIVE_LIST_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {

            setOrderFromDate(dayjs(data[0].received_date));

            setInvoiceNumber(data[0].invoice_number);
            setInvoiceDate(dayjs(data[0].invoice_date));
            setCustomerNotes(data[0].receive_notes);
            setDODate(dayjs(data[0].do_date));
            setDONumber(data[0].do_number);
            // setSelectedPONumber(data[0].purchase_receive_number);

            receivedByHook.setSelectedEmployeeID(data[0].id_received_by);
            // approvedByHook.setSelectedEmployeeID(data[0].id_approved_by);
            // inspiredByHook.setSelectedEmployeeID(data[0].id_inspected_by);

            const selectedreceived = receivedByHook.employee.find(emp => emp.id === data[0].id_received_by);
            receivedByHook.setSelectedEmployee(selectedreceived);
            // const selectedapproved = approvedByHook.employee.find(emp => emp.id === data[0].id_approved_by);
            // approvedByHook.setSelectedEmployee(selectedapproved);
            // const selectedinsepired = inspiredByHook.employee.find(emp => emp.id === data[0].id_inspected_by);
            // inspiredByHook.setSelectedEmployee(selectedinsepired);

            loadPartyListByCategory(data[0].id_transporter, 'Transporter');
            setVehicleNumber(data[0].vehicle_number);

            setUpdateReceivedDetail(true);


          }

        })
        .catch(error => { callMessage('error', error.message, 'Error'); });

    }


  }, [isPRNumberLoaded, receivedByHook.employee, approvedByHook.employee, inspiredByHook.employee]);


  useEffect(() => {
    if (updateReceivedDetail) {

    }

  }, [updateReceivedDetail])


  const handleSaveAndDraft = () => {




    const modifiedRows = tableRows.map(({ product, account, ...rest }) => rest);
    let mode = editPurchaseReceiveID !== 0 ? 1 : 0;

    // Validation
    const errors = [];

    if (!selectedPartyID) errors.push("Party must be selected.");
    if (!selectedPOID) errors.push("PO Number is required.");
    if (!prNumber) errors.push("PR Number is required.");
    if (!orderFromDate) errors.push("Order Date is required.");
    if (modifiedRows.length === 0) errors.push("At least one product row is required.");
    // if (!approvedByHook.selectedEmployeeID) errors.push("Approved By is required.");
   
    // if (!inspiredByHook.selectedEmployeeID) errors.push("Inspected By is required.");
    if (!invoiceNumber) errors.push("Invoice Number is required.");
    if (!invoiceDate) errors.push("Invoice Date is required.");
    if (!selectedpartyByTypeID) errors.push("Transporter must be selected.");
    if (!vehicleNumber) errors.push("Vehicle Number is required.");
    // if (!doNumber) errors.push("DO Number is required.");
    // if (!doDate) errors.push("DO Date is required.");
     if (!receivedByHook.selectedEmployeeID) errors.push("Received By is required.");

    // Show errors if any
    if (errors.length > 0) {
      callMessage('warning', errors.join('\n'), 'Validation');
      return; // stop API call
    }

    const requestBody = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_modeid: mode,
      p_partyid: selectedPartyID,
      p_po_number_id: selectedPOID,
      p_pr_number: prNumber,
      p_date: dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss'),
      p_customer_notes: customerNotes,
      p_product_list: modifiedRows,
      p_approvedby: approvedByHook.selectedEmployeeID,
      p_receivedby: receivedByHook.selectedEmployeeID,
      p_insepiredby: inspiredByHook.selectedEmployeeID,
      p_invoice_number: invoiceNumber,
      p_invoice_date: dayjs(invoiceDate).format('YYYY-MM-DD hh:mm:ss'),
      p_transporterid: selectedpartyByTypeID,
      p_vehicle_no: vehicleNumber,
      p_do_no: doNumber,
      p_do_date: dayjs(doDate).format('YYYY-MM-DD hh:mm:ss'),
    }

    callApi(API_ENDPOINTS.PURCHASE_CREATE_RECEIVE, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        if (data && data.length > 0) {
          callMessage('info', 'New Purchase Receive Added Successfully', 'info');
          setDisableSaveBtn(true);
        }
        else {
          setDisableSaveBtn(false);
        }
      })
      .catch(error => { callMessage('error', error.message, 'Error'); });
  };



  const [allPOData, setAllPOData] = useState({});
  const updateFormData = (productData, purchaseOrder) => {
    const subtotal = productData.reduce((sum, item) => sum + item.amount, 0);
    const totalQuantity = productData.reduce((sum, item) => sum + item.quantity, 0);

    const formData = {
      partyName: purchaseOrder.company, // Update as per your requirement
      purchaseOrderNumber: purchaseOrder.purchase_order_number,
      referenceNumber: purchaseOrder.reference,
      date: dayjs(purchaseOrder.po_date).format('DD-MMM-YYYY'),
      expectedDeliveryDate: dayjs(purchaseOrder.expiry_delivery_date).format('DD-MMM-YYYY'),
      paymentTerms: purchaseOrder.payment_description, // Fetch from data if available
      shipmentPreference: purchaseOrder.shipment_reference,
      products: productData.map(item => ({
        code: item.product_code,
        description: item.product_description,
        // account: item.account.description,
        ordered: item.ordered,
        received: item.received,
        quantity_balance: item.quantity_balance,
        quantity_to_received: item.quantity_to_received,
      })),
      customerNotes: purchaseOrder.customer_notes,
      termsConditions: purchaseOrder.terms_conditions,
      subtotal: subtotal,
      totalQuantity: totalQuantity,
      discountPercentage: purchaseOrder.discount_percentage, // Fetch from data if available
      discountValue: purchaseOrder.discount_value,
      adjustment: purchaseOrder.adjustment_value,
      tcsPercentage: '1%', // Fetch from data if available
      tcsValue: purchaseOrder.tcs_value,
      cgstPercentage: purchaseOrder.cgst_percentage,
      cgst: purchaseOrder.cgst,
      sgstPercentage: purchaseOrder.sgst_percentage,
      sgst: purchaseOrder.sgst,
      // total: subtotal - (subtotal * 0.05) + adjustment + (subtotal * 0.01), // Example calculation
      fright: purchaseOrder.fright,
    };
    setAllPOData(formData);
    // Generate PDF (example)
    // generatePDF(formData);
  };

  useEffect(() => {
    if (vendorDetails.length > 0 && receivesDetail.length > 0) {
      const updatedPOData = {
        ...allPOData,
        supplier: vendorDetails,
        company: companyDetails,

        purchase_received_no: prNumber,
        purchase_received_date: dayjs(orderFromDate).format('DD-MMM-YYYY'),
        party_invoice_no: invoiceNumber,
        party_invoice_date: dayjs(invoiceDate).format('DD-MMM-YYYY'),
        received_by: receivedByHook.selectedEmployee.name,
        approved_by: approvedByHook.selectedEmployee.name,
        inspired_by: inspiredByHook.selectedEmployee.name,
        received_notes: customerNotes,
        transporter: selectedpartyByType.companyname,
        vehicle_number: vehicleNumber,
        do_number: doNumber,
        do_date: dayjs(doDate).format('DD-MMM-YYYY'),
        receives_table_det: receivesDetail,

      }
      setAllPOData(updatedPOData);
      // }
      generatePDF();
    }
  }, [vendorDetails])

  const handlecallProcess = (buttonName) => {
    if (buttonName === 'PDF') {
      // const updates = {
      //   purchase_order_no: prNumber,
      //   purchase_order_date: dayjs(orderFromDate).format('DD-MMM-YYYY'),
      //   party_invoice_no: invoiceNumber,
      //   party_invoice_date: dayjs(invoiceDate).format('DD-MMM-YYYY'),
      //   received_by: receivedByHook.selectedEmployee.name,
      //   approved_by: approvedByHook.selectedEmployee.name,
      //   inspired_by: inspiredByHook.selectedEmployee.name,
      // };

      // const updatedPOData = {
      //   ...allPOData,
      //   ...Object.fromEntries(
      //     Object.entries(updates).filter(([key]) => key in allPOData)
      //   ),
      // };

      // setAllPOData(updatedPOData);

      // const updatedPOData = {
      //   ...allPOData,
      //   purchase_received_no: prNumber,
      //   purchase_received_date:dayjs(orderFromDate).format('DD-MMM-YYYY'),
      //   party_invoice_no:invoiceNumber,
      //   party_invoice_date:dayjs(invoiceDate).format('DD-MMM-YYYY'),
      //   received_by: receivedByHook.selectedEmployee.name,
      //   approved_by: approvedByHook.selectedEmployee.name,
      //   inspired_by: inspiredByHook.selectedEmployee.name,

      // }
      // setAllPOData(updatedPOData);

      generatePDF();
    }
    else if (buttonName === 'selectAll') {
      callbackPdf();
    }
  }

  const reportRef = useRef();
  const [viewPurchaseReport, setViewPurchaseReport] = useState(false);

  const [viewPurchaseOrder, setViewPurchaseOrder] = useState(true);
  const [viewPurchaseReceive, setViewPurchaseReceive] = useState(false);
  const [viewPurchaseBill, setViewPurchaseBill] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  const generatePDF = () => {
    setViewPurchaseOrder(false);
    setViewPurchaseReceive(false);
    setViewPurchaseBill(false);
    setViewPurchaseReport(true);

    // const doc = new jsPDF({
    //   format: 'a4',
    //   unit: 'pt'
    // });

    // doc.html(reportRef.current, {
    //   callback: function (doc) {
    //     doc.save('purchase_order_report.pdf');
    //   },
    //   x: 10,
    //   y: 10,
    //   width: 575, // A4 page width - margins
    //   windowWidth: 800, // The window width to use for rendering
    // });
  };

  const callbackPdf = () => {
    setViewPurchaseOrder(true);
    setViewPurchaseReceive(false);
    setViewPurchaseReport(false);
  }


  return (<>

    {viewPurchaseOrder && (
      <Box padding={0}>

        <Header title={editPurchaseOrderNumber == 0 ? 'New Goods Receives' : 'Edit Goods Receives'} subtitle="" callback={callback} />
        <Divider />
        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseReceiveActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}

        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

      <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      px: 1,
                      py: 1
                    }}
                  >
                    <Typography variant="h6"  >
                      <span style={{ color: 'red' }}>*</span> Mandatory fields
                    </Typography>
                  </Box>
        <ResponsiveBox
          customMaxHeight={{
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          }}>
          <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >

    

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
            
              <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center">

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Party Name <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={partyList}
                    value={selectedParty}
                    onChange={(event, newValue) => {
                      setSelectedParty(newValue);
                      setSelectedPartyID(newValue.id);
                      handleGetPOList(newValue.id);
                    }}
                    getOptionLabel={(option) => option.companyname || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>

              </Grid>
              <Grid container padding="10px 0px 25px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >
                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Purchase Order # <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>

                  <Autocomplete
                    size="small"
                    fullWidth
                    options={poNumber}
                    value={selectedPONumber}
                    onChange={(event, newValue) => {
                      setSelectedPONumber(newValue);
                      setSelectedPOID(newValue.id);
                      LoadReceivesDetails(newValue.id);

                    }}
                    getOptionLabel={(option) => option.po_number || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>



            <Grid item xs={12} xl={12} >

              <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >
                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Goods Receipt No# <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <TextField value={prNumber} fullWidth size="small" label="" required variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CustomTooltip
                            title={
                              <span>
                                <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                              </span>}
                          >
                            <SettingsIcon style={{ fontSize: "20px" }} />
                          </CustomTooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Received Date <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={dayjs(orderFromDate)}
                        format="DD-MMM-YYYY"
                        onChange={(date) => setOrderFromDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Party Invoice# <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <TextField value={invoiceNumber} onChange={(e) => (setInvoiceNumber(e.target.value))} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Party Invoice Date <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Invoicedate"
                               format="DD-MMM-YYYY"
                        value={dayjs(invoiceDate)}
                        onChange={(date) => setInvoiceDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >

              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Transporter <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2} >
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={partyByType}
                    value={selectedpartyByType}
                    onChange={(event, newValue) => {
                      loadPartyListByCategory(newValue.id, 'Transporter');
                    }}
                    getOptionLabel={(option) => option.companyname || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Vehicle No <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <TextField value={vehicleNumber} onChange={(e) => (setVehicleNumber(e.target.value))} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >

              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Delivery Challan No <span style={{ color: '#d32f2f', fontWeight: 600 }}></span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2} >
                  <TextField value={doNumber} onChange={(e) => (setDONumber(e.target.value))} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Delivery Challan Date <span style={{ color: '#d32f2f', fontWeight: 600 }}></span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                               format="DD-MMM-YYYY"
                        id="Invoicedate"
                        value={dayjs(doDate)}
                        onChange={(date) => setDODate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>

              </Grid>
            </Grid>


            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Received By <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <EmployeeSelector
                    // label="Received By"
                    employeeList={receivedByHook.employee}
                    selectedEmployee={receivedByHook.selectedEmployee}
                    onChange={(val) => {
                      receivedByHook.setSelectedEmployee(val);
                      receivedByHook.setSelectedEmployeeID(val?.id);
                    }}
                  />

                </Grid>

                {/* <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Inspected By
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <EmployeeSelector
                    // label="Inspected By"
                    employeeList={inspiredByHook.employee}
                    selectedEmployee={inspiredByHook.selectedEmployee}
                    onChange={(val) => {
                      inspiredByHook.setSelectedEmployee(val);
                      inspiredByHook.setSelectedEmployeeID(val?.id);
                    }}
                  />
                </Grid> */}

              </Grid>
            </Grid>

            {/* <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Approved By
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                  <EmployeeSelector
                    // label="Approved By"
                    employeeList={approvedByHook.employee}
                    selectedEmployee={approvedByHook.selectedEmployee}
                    onChange={(val) => {
                      approvedByHook.setSelectedEmployee(val);
                      approvedByHook.setSelectedEmployeeID(val?.id);
                    }}
                  />
                </Grid>

              </Grid>
            </Grid> */}

            <Grid item xs={12} xl={12} >
              <Divider sx={{ marginTop: "20px" }} />
            </Grid>



            <Grid item xs={12} lg={9.8} xl={6.5} mt={1} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                  <CustomTableContainer colors={colors}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Product</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Ordered</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Received</TableCell>
                             <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>UOM</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>In Trasit</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity to Receive</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableRows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'left',
                                    },
                                  }}
                                  variant="outlined"
                                  type="text"
                                  value={`${row.product_code} - ${row.product_description}`}
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.ordered}

                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.received}
                                />
                              </TableCell>
                               <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                               
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'left',
                                    },
                                  }}
                                  variant="outlined"
                                  type="text"
                                   value={row.material_uom}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  value={row.in_transit}
                                  variant="outlined"
                                  disabled
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity_to_received}
                                  onChange={(e) => handleQuantityChange(index, e.target.value)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CustomTableContainer>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
              <Box padding="10px 0px 0px 20px" sx={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 2,
                color: 'text.secondary', '& svg': { m: 1, },
              }} >
                <Grid container spacing={0}>
                  <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                    <Typography variant="h5" fontWeight="bold">Notes (For Internal Use) </Typography>
                    <Grid item xs={12} lg={12} xl={10}>
                      <TextField
                        id="outlined-multiline-static"
                        value={customerNotes}
                        onChange={(e) => setCustomerNotes(e.target.value)}
                        placeholder="Enter the customer notes , will appear the purchase order."
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

          </Grid>
        </ResponsiveBox>


        <Grid container>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
              <Toolbar>
                <Button size="small" variant="contained" color="secondary" disabled={disableSaveBtn} onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Received</Button>
                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
              </Toolbar>
            </Box>
          </Grid>
        </Grid>

      </Box>
    )}

    {viewPurchaseReport && (
      <Box padding={0}>
        <Header title={prNumber} subtitle="" callback={callbackPdf} />
        <Divider />

        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseReceiveActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}

        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


        <ResponsiveBox
          customMaxHeight={{
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          }}>
          <Box padding={1}>
            {/* <PurchaseReceivePDF poData={allPOData} /> */}
            <GoodsReceiptNote poData={allPOData} />
          </Box>
        </ResponsiveBox>

      </Box>
    )}

  </>)
}
export default AddNewPurchaseReceive;